import { GROUP } from 'src/constants'

// form fields
export const REFERRAL_FIRSTNAME_FIELDNAME = 'firstName'
export const REFERRAL_LASTNAME_FIELDNAME = 'lastName'
export const REFERRAL_PHONE_FIELDNAME = 'phone'
export const REFERRAL_MIDDLENAME_FIELDNAME = 'middleName'
export const REFERRAL_ENROLLMENTSPECIALIST_FIELDNAME = 'enrollmentSpecialist'
export const REFERRAL_BESTDAYTOCALL_FIELDNAME = 'bestDayToCall'
export const REFERRAL_DATE_FIELDNAME = 'referralDate'
export const REFERRAL_IMPORT_TYPE_FIELDNAME = 'creationType'
export const REFERRAL_BESTTIMETOCALL_FIELDNAME = 'bestTimeToCall'
export const REFERRAL_REFERRALSOURCE_FIELDNAME = 'referralSource'
export const REFERRAL_REFERRALSOURCE_SUBGROUP_FIELDNAME =
  'referralSourceSubGroup'
export const REFERRAL_REFERRALREASON_FIELDNAME = 'referralReason'
export const REFERRAL_NOTE_FIELDNAME = 'note'
export const REFERRAL_GENDER_FIELDNAME = 'gender'
export const REFERRAL_PRIMARYLANGUAGE_FIELDNAME = 'primaryLanguage'
export const REFERRAL_SECONDARYLANGUAGES_FIELDNAME = 'secondaryLanguages'
export const REFERRAL_DOB_FIELDNAME = 'dob'
export const REFERRAL_PHONES = 'phones'
export const REFERRAL_INSURANCES = 'insurances'
export const REFERRAL_PROVIDER_FIELDNAME = 'provider'
export const REFERRAL_ACCOUNT_MANAGER_FIELDNAME = 'accountManager'
export const REFERRAL_AGENCYCASEMANAGER_FIELDNAME = 'agencyCaseManager'
export const REFERRAL_AGENCYMARKETER_FIELDNAME = 'agencyMarketer'
export const REFERRAL_REFERREDFOR_FIELDNAME = 'referredFor'
export const REFERRAL_REFERRAL_REASON_FIELDNAME = 'referralReason'
export const REFERRAL_EXTERNALID_FIELDNAME = 'externalId'
export const REFERRAL_RELATION_DOCUMENTS = 'documents'
export const REFERRAL_RELATION_ADRESSES = 'addresses'
export const REFERRAL_RELATION_EMERGENCYCONTACTS = 'emergencyContacts'
export const REFERRAL_RELATION_PROBLEMS = 'diseases'
export const REFERRAL_RELATION_DIAGNOSES = 'diagnoses'

// props
export const REFERRAL_REFERRALID_PROPNAME = 'referralId'
export const REFERRAL_REFERRALDATE_PROPNAME = 'createdAt'
export const REFERRAL_REFERRALDATE_PATIENT_PROPNAME = 'referralDate'
export const REFERRAL_CREATEDBY_PROPNAME = 'createdBy'
export const REFERRAL_FOLLOWUPDATE_PROPNAME = 'followUpDate'
export const REFERRAL_LASTATTEMPTDATE_PROPNAME = 'lastAttemptDate'
export const REFERRAL_FULLNAME_PROPNAME = 'fullName'
export const REFERRAL_NAME_PROPNAME = 'name'
export const REFERRAL_ATTEMPTCOUNT_PROPNAME = 'attemptCount'
export const REFERRAL_INSURANCES_PROPNAME = 'insurance'
export const REFERRAL_OUTREACHSTATUS_PROPNAME = 'outreachStatus'
export const REFERRAL_STATUS_PROPNAME = 'outreachStatus'
export const REFERRAL_PRIMARYINSURANCE_PROPNAME = 'primaryInsurance'
export const REFERRAL_PRIMARYADDRESS_PROPNAME = 'primaryAddress'
export const REFERRAL_PHONES_PROPNAME = 'phones'

// export aliases
export const REFERRAL_EXPORT_STATUS_PROPNAME = 'status'
export const REFERRAL_EXPORT_SECONDARYLANGUAGES_FIELDNAME = 'secondaryLanguage'

// i18n later on
export const REFERRAL_DELETE_CONFIRM_MESSAGE = (name = '') =>
  `Do you want to delete the referral record for ${name}`

// sort options
export const REFERRAL_SEARCH_DEFAULT_SORT = {
  sortedColumn: REFERRAL_FOLLOWUPDATE_PROPNAME,
  sortedColumnOrder: 'ascend'
}

// select options
export const REFERRAL_REFERREDFOR_OPTIONS = [
  {
    value: 1,
    label: 'CCM'
  },
  {
    value: 6,
    label: 'CoCM'
  },
  {
    value: 2,
    label: 'RPM'
  },
  {
    value: 3,
    label: 'RTM'
  },
  {
    value: 4,
    label: 'BHI'
  },
  {
    value: 5,
    label: 'APCM'
  },
  {
    value: 7,
    label: 'PIN'
  },
  {
    value: 8,
    label: 'CHI'
  },
  {
    value: 9,
    label: 'PCM'
  }
]

export const REFERRAL_BESTTIMETOCALL_OPTIONS = [
  {
    value: '9am-12pm',
    label: '9AM -12PM'
  },
  {
    value: '12pm-2pm',
    label: '12PM-2PM'
  },
  {
    value: '2pm-5pm',
    label: '2PM-5PM'
  }
]

export const REFERRAL_BESTDAYTOCALL_OPTIONS = [
  {
    value: 1,
    label: 'Mon'
  },
  {
    value: 2,
    label: 'Tue'
  },
  {
    value: 3,
    label: 'Wed'
  },
  {
    value: 4,
    label: 'Thu'
  },
  {
    value: 5,
    label: 'Fri'
  }
]

export const REFERRAL_OUTREACH_STATUSES_GROUPS = {
  1: 'New',
  2: 'In progress',
  3: 'Closed/Declined',
  4: 'Enrolled'
}

export const REFERRAL_OUTREACH_STATUSES_BY_NAME = new Map([
  ['New', 1],
  ['In progress', 2],
  ['Closed/Declined', 3],
  ['Enrolled', 4]
])

export const REFERRAL_OUTREACH_STATUSES_GROUPS_DEFAULT_FILTER = [1, 2]

// queries
export const REFERRAL_ENROLMENTSPECIALISTS_QUERY = {
  'filter[isEnrollmentSpecialist]': 'eq:1',
  'per-page': 10000,
  sort: 'lastName:asc'
}

// export const REFERRAL_AGENCYCASEMANAGER_QUERY = {
//   'filter[isActive]': 'eq:1',
//   'filter[referralSource]': `in:${changedData[property].uuid}`,
//   'per-page': 10000,
//   sort: 'lastName:asc'
// }

export const creationTypes = [
  {
    title: 'EMR Portal',
    value: 1
  },
  {
    title: 'Care Portal',
    value: 2
  },
  {
    title: 'HHAX Extension',
    value: 3
  },
  {
    title: 'CSV File Import',
    value: 4
  },
  {
    title: 'Oasis File',
    value: 5
  },
  {
    title: 'API Integration',
    value: 6
  },
  {
    title: 'Anonymous Link',
    value: 7
  }
]

export const REFERRAL_EXPORT_FIELDS = [
  {
    title: 'Referral ID',
    fieldName: REFERRAL_REFERRALID_PROPNAME,
    disabled: true,
    selected: true
  },
  {
    title: 'External ID',
    fieldName: REFERRAL_EXTERNALID_FIELDNAME,
    selected: true
  },
  {
    title: 'Name',
    fieldName: REFERRAL_NAME_PROPNAME,
    disabled: true,
    selected: true
  },
  {
    title: 'DOB',
    fieldName: REFERRAL_DOB_FIELDNAME,
    selected: true
  },
  {
    title: 'Referred for',
    fieldName: REFERRAL_REFERREDFOR_FIELDNAME,
    selected: true
  },
  {
    title: 'Referral Reason',
    fieldName: REFERRAL_REFERRAL_REASON_FIELDNAME,
    selected: false
  },
  {
    title: 'Enrollment Specialist',
    fieldName: REFERRAL_ENROLLMENTSPECIALIST_FIELDNAME,
    selected: true
  },
  {
    title: 'Status',
    fieldName: REFERRAL_EXPORT_STATUS_PROPNAME
  },
  {
    title: 'Primary language',
    fieldName: REFERRAL_PRIMARYLANGUAGE_FIELDNAME,
    selected: true
  },
  {
    title: 'Secondary language',
    fieldName: REFERRAL_EXPORT_SECONDARYLANGUAGES_FIELDNAME
  },
  {
    title: 'Provider',
    fieldName: REFERRAL_PROVIDER_FIELDNAME,
    selected: true
  },
  {
    title: '# of attempts',
    fieldName: REFERRAL_ATTEMPTCOUNT_PROPNAME,
    selected: true
  },
  {
    title: 'Last attempt date',
    fieldName: REFERRAL_LASTATTEMPTDATE_PROPNAME,
    selected: true
  },
  {
    title: 'Follow up date',
    fieldName: REFERRAL_FOLLOWUPDATE_PROPNAME,
    selected: true
  },
  {
    title: 'Primary insurance',
    fieldName: REFERRAL_PRIMARYINSURANCE_PROPNAME,
    selected: true
  },
  {
    title: 'Phones',
    fieldName: REFERRAL_PHONES_PROPNAME
  },
  {
    title: 'Primary address',
    fieldName: REFERRAL_PRIMARYADDRESS_PROPNAME
  },
  {
    title: 'Referral source',
    fieldName: REFERRAL_REFERRALSOURCE_FIELDNAME,
    selected: true
  },
  {
    title: 'Referral Source Sub-group',
    fieldName: REFERRAL_REFERRALSOURCE_SUBGROUP_FIELDNAME,
    selected: true
  },
  {
    title: 'Agency Case Manager',
    fieldName: REFERRAL_AGENCYCASEMANAGER_FIELDNAME,
    selected: true
  },
  {
    title: 'Agency Marketer',
    fieldName: REFERRAL_AGENCYMARKETER_FIELDNAME,
    selected: false
  },
  {
    title: 'Referral Group',
    fieldName: GROUP,
    selected: true
  },
  {
    title: 'Referral Date',
    fieldName: REFERRAL_DATE_FIELDNAME,
    selected: true
  },
  {
    title: 'Import type',
    fieldName: REFERRAL_IMPORT_TYPE_FIELDNAME,
    selected: false
  }
]
